import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@approot/utilities';
const { cleanFormattedNumeric } = Utilities;
@Pipe({
  name: 'cleanFormattedNumeric'
})
export class CleanFormattedNumericPipe implements PipeTransform {
  transform(value: number | string): number {
    return cleanFormattedNumeric(value);
  }
}
